import React from "react";
import { withStyles } from "@material-ui/core/styles";
import VerticalTabs from "./verticalTabs";
import Header from "./header";
import moment from "moment";
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Loader from "./subComponents/loader";
import MuiAlert from '@material-ui/lab/Alert';
import { CommonConstant } from "../constants/common.constant";
import Snackbar from '@material-ui/core/Snackbar';
import ErrorModal from "./subComponents/errorModal";
import AppWrapperStyle from "../styles/appWrapperStyle";

// used for session of 20 minute
let idleTime = 0;


const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class AppWrapper extends React.Component {

  state = { showLogoutWarning: false }

  UNSAFE_componentWillMount() {
    let lastSavedTime = localStorage.getItem('ppLastSavedTime');
    if (!lastSavedTime) {
      this.clearStorage();
    } else {
      let timeDiff = this.checkTimeDiff(lastSavedTime);
      if (timeDiff > 20) {
        this.clearStorage();
      }
    }
  }

  componentDidMount() {
    let { GetHeaderInfo } = this.props;
    if (localStorage.getItem('userId')) {
      GetHeaderInfo && GetHeaderInfo(localStorage.getItem('userId'));
    } else {
      window.location.href = process.env.REACT_APP_LOGOUT_URL;
    }
    // clear the session on refresh
    window && window.addEventListener('unload', () => {
      let lastSavedTime = localStorage.getItem('ppLastSavedTime');
      let timeDiff = this.checkTimeDiff(lastSavedTime);
      if (timeDiff > 20) {
        this.clearStorage();
        localStorage.removeItem('ppLastSavedTime');
      }
      else {
        localStorage.setItem('ppLastSavedTime', new Date());
      }
    });
    this.setSession();
  }

  ////session of 20 minute
  setSession = () => {
    this.idleInterval = setInterval(this.timerIncrement, 60000); // 1 minute
    window && window.addEventListener('mousemove', this.setIdleTime);
    window && window.addEventListener('keypress', this.setIdleTime);
  }

  setIdleTime = () => {
    if (this.state.showLogoutWarning) {
      this.setState({ showLogoutWarning: false });
    }
    idleTime = 0;
  }

  timerIncrement = () => {
    idleTime = idleTime + 1;
    // replace to 17
    if (idleTime > 17) {
      this.setState({ showLogoutWarning: true });
    }
    //replace to 19
    if (idleTime > 19) { // 20 minutes
      this.clearStorage();
      localStorage.removeItem('ppLastSavedTime');
      window.location.reload();
    }
  }

  clearStorage = () => {
    let { LogOff } = this.props;
    this.idleInterval && clearInterval(this.idleInterval);
    LogOff && LogOff();
  }

  showAlert = (e) => {
    if (e) {
      e.preventDefault();
      e.returnValue = '';
    }
  }


  checkTimeDiff = (lastSavedTime) => {
    let now = moment(new Date()); //current time
    let end = moment(lastSavedTime); // saved time
    return now.diff(end, "minutes");
  }

  UNSAFE_componentWillUnmount() {
    // remove event listner
    window && window.removeEventListener('mousemove', this.setIdleTime);
    window && window.removeEventListener('keypress', this.setIdleTime);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.callStarted && this.props.callStarted) {
      window.addEventListener('beforeunload', this.showAlert);
    } else if (prevProps.callStarted && !this.props.callStarted) {
      window.removeEventListener('beforeunload', this.showAlert)
    }
  }

  handleLogoutWarningClose = () => {
    this.setState({ showLogoutWarning: false })
  }

  render() {
    const { classes, modalOpen, ToggleModal, loading, errorModalOpen, ToggleErrorModal, loggedOff } = this.props;
    let restProps = { ...this.props };
    delete restProps.classes;
    if (!localStorage.getItem('userId') || loggedOff) {
      return null;
    }
    return (
      <div data-app="app-component-wrapper" style={{ display: "flex", flexDirection: "column", flex: 1 }}>
        <div className={classes.headerStyle}>
          <Header
            selectedPrescriberInfo={this.props.selectedPrescriberInfo}
            callStarted={this.props.callStarted}
            LogOff={this.props.LogOff}
            login
          />
        </div>
        <div style={{ flex: 1, display: "flex", overflowY: "auto" }}>
          <VerticalTabs {...restProps} />
        </div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          style={{ zIndex: 130 }}
          open={modalOpen}
          id="page-exit-modal"
          onClose={() => ToggleModal(false)}
          closeAfterTransition
          BackdropComponent={() => <Backdrop onClick={() => ToggleModal(false)} style={{ visibility: "visible" }} />}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={modalOpen}>
            <div data-app="modal-app-component-wrapper" className={classes.modalBody}>
              <div id="page-exit-modal-text" className={classes.modalText}>Are you sure you want to leave this page?</div>
              <div className={classes.modalActionContainer}>
                <a id="leave-button" style={{ textDecoration: "none", height: 56, outline: "none" }} href={`${CommonConstant.LEGACY_URL}Patients/MyPatients`}><div tabIndex={0} className={classes.trueButton}>Yes, leave page</div></a>
                <div id="dont-leave-button" tabIndex={0} onClick={() => ToggleModal(false)} className={classes.falseButton}>No, do not</div>
              </div>
            </div>
          </Fade>
        </Modal>
        <ErrorModal modalOpen={errorModalOpen} closeModal={() => ToggleErrorModal(false)} />
        {loading ? <Loader /> : null}
        <Snackbar data-app="snackbar-component-wrapper" open={this.state.showLogoutWarning} onClose={this.handleLogoutWarningClose}>
          <Alert classes={{ root: classes.standardWarning }} severity="warning">
            Your session will expire in 2 minutes due to inactivity.
        </Alert>
        </Snackbar>
      </div>
    );
  }
}

export default withStyles(AppWrapperStyle)(AppWrapper);